'format es6';

import $ from 'jquery';
import 'parsleyjs';

$(()=>{

    let parsleyConfig = {
        errorsContainer: parsleyField => {
            let fieldSet = parsleyField.$element.closest('.form-group');

            return fieldSet;
        }
    };
    $('form[data-validate]').parsley(parsleyConfig);

    setupPage();
});

$(window).resize(setupPage);

function setupPage() {

}




function pageLoaded()
{

}
